export const validator = ({ name, totalAmount }) => {
  const validation = { name: null, totalAmount: null }

  if (totalAmount === null) {
    validation.totalAmount = "Amount can not be blank."
  }

  if (name === null || name.trim() === "") {
    validation.name = "Name can't be blank."
  }

  return validation
}
